'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.botTypingMessageReceived = undefined;

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _startBotTyping = require('./startBotTyping');

var botTypingMessageReceived = exports.botTypingMessageReceived = function botTypingMessageReceived(message) {
  return function (dispatch) {
    var threadId = (0, _pubnubMessageGetters.getThreadId)(message);
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    dispatch((0, _startBotTyping.startBotTyping)(threadId, senderId));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/botTypingMessageReceived.js
// module id = 420
// module chunks = 2 3